import _regeneratorRuntime from "@babel/runtime/regenerator";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var AUTH_LAST_LOGIN_TYPE = 'auth_last_login_type';
export var UMS_CAPCHA_CODE = [1001045, 1001046]; // 用于区分站点，UMS & UC 融合需要区分 www.gaoding & qiye.gaoding

export var DEFAULT_SITE_TYPE = 'www.gaoding';
export var LOGIN_TYPE = {
  QIYE_WECHAT: 'wechat.qiye',
  QIYE_WECHAT_BINDPHONE: 'wechat.qiye.bindphone',
  AUTH_CODE: "auth.code"
};
export function SET_LAST_LOGIN_TYPE(_x, _x2) {
  return _SET_LAST_LOGIN_TYPE.apply(this, arguments);
}

function _SET_LAST_LOGIN_TYPE() {
  _SET_LAST_LOGIN_TYPE = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(oauth2Client, type) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!((typeof localStorage === "undefined" ? "undefined" : _typeof(localStorage)) !== 'object')) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            if (['phone', 'smsLogin', 'email', 'emailCode', 'wechat'].includes(type)) {
              oauth2Client.setExtraData(AUTH_LAST_LOGIN_TYPE, type);
              localStorage.setItem(AUTH_LAST_LOGIN_TYPE, type);
            }

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _SET_LAST_LOGIN_TYPE.apply(this, arguments);
}

export function GET_LAST_LOGIN_TYPE(oauth2Client, callback) {
  if ((typeof localStorage === "undefined" ? "undefined" : _typeof(localStorage)) !== 'object') {
    return;
  }

  oauth2Client.getExtraData(AUTH_LAST_LOGIN_TYPE).then(function (loginType) {
    if (loginType) {
      SET_LAST_LOGIN_TYPE(oauth2Client, loginType);
      callback(loginType);
    }
  });
  return localStorage.getItem(AUTH_LAST_LOGIN_TYPE);
}